import { Field } from 'formik'
import { DSIHtml } from 'shared'
import { DataTransferPopover, FormCheckbox } from '../shared'

export const DataTransferCheckbox = ({ display }) => {
  return <div className='iframe-donations-data-transfer-checkbox'>
    <div className='mb-3 mt-3'>
      <Field name='allow_data_transfer' label={<LabelWithPopover display={display} />} component={FormCheckbox} />
    </div>
  </div>
}

const LabelWithPopover = ({ display }) => {
  return <div className="___popover-body">
    <DSIHtml value={I18n.t('donate.components.data_transfer_checkbox.explanation_html', { carrier_name: display.carrierName })} />
    &nbsp;
      <DataTransferPopover
      name={display.carrierName}
      street={display.street}
      zip={display.zip}
      city={display.city}
    />
  </div>
}
